import { NgModule } from '@angular/core';

import { IconsContainerComponent } from './icons-container.component';

@NgModule({
  declarations: [IconsContainerComponent],
  exports: [IconsContainerComponent],
})
export class IconsContainerModule {}
export { IconsContainerComponent };
export { IconName } from './icons.type';
